import { cn } from "@/lib/utils";
import type { DocChatItem } from "@/lib/erp/docs";

type ReactionPillsProps = {
  reactions: NonNullable<DocChatItem["reactions"]>;
  onToggle: (emoji: string) => void;
};

export function ReactionPills({ reactions, onToggle }: ReactionPillsProps) {
  if (reactions.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1 mt-1">
      {reactions.map((reaction) => (
        <button
          key={reaction.emoji}
          type="button"
          onClick={() => onToggle(reaction.emoji)}
          className={cn(
            "inline-flex items-center gap-1 rounded-full px-2 py-0.5",
            "text-xs font-medium transition-all",
            "hover:bg-muted/80 active:scale-95",
            "min-h-[28px] min-w-[28px]",
            reaction.has_reacted
              ? "bg-primary/10 ring-2 ring-primary/30"
              : "bg-muted/60"
          )}
          aria-label={`${reaction.emoji} ${reaction.count} reaction${reaction.count !== 1 ? "s" : ""}${reaction.has_reacted ? ", you reacted" : ""}`}
        >
          <span className="text-sm leading-none">{reaction.emoji}</span>
          <span className="text-xs tabular-nums text-foreground">{reaction.count}</span>
        </button>
      ))}
    </div>
  );
}
